import React from 'react';
import {observer} from 'mobx-react';
import {withState} from 'shared/core';
import {TaxableBenefitsContainerState} from '../state';
import {BenefitDivisionTable} from 'taxable_benefits/components/divisions';
import {Layout, Panel} from 'components';

const TaxableBenefitsContainerWithState = observer(({uiState}) => {
  const {benefitDivisions, history, match} = uiState;

  return (
    <Layout>
      <Panel.Stack loose>
        {benefitDivisions.map(benefitDivision => 
          <BenefitDivisionTable 
            key={benefitDivision.id}
            match={match}
            history={history} 
            benefitDivision={benefitDivision} 
          />
        )}
      </Panel.Stack>
    </Layout>
  );
});

export default withState(TaxableBenefitsContainerWithState, TaxableBenefitsContainerState);
